var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Plate',{attrs:{"agent":_vm.agent,"lead":_vm.lead,"beneficiary":_vm.beneficiary}},[_c(_vm.platesByStep[_vm.step],{tag:"component",attrs:{"agent":_vm.agent,"lead":_vm.lead,"beneficiary":_vm.beneficiary}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }